var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotVerified(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.913,
    cy: 12,
    r: 12,
    fill: "#FDECEB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.978 9.16a.5.5 0 10-.707-.707l-2.822 2.82-2.821-2.82a.5.5 0 00-.707.706l2.821 2.822-2.821 2.822a.5.5 0 10.707.707l2.822-2.822 2.82 2.821a.5.5 0 10.708-.707l-2.821-2.821 2.82-2.821z",
    fill: "#F65B51"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotVerified);
export default __webpack_public_path__ + "static/media/notVerified.d60261faba20a20b1b38697b6870c398.svg";
export { ForwardRef as ReactComponent };